import { Box, Grid, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { Typography } from '@mui/material'
import constants from '../../utils/constants'
import { CommonButton, CommonInput } from '../common/CommonElements'
import { forgotPassword } from '../../services/authApis'
import { useNavigate } from 'react-router-dom'


const Forgotten = () => {
    const theme = useTheme()
    const [email, setEmail] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('')
    const [success, setSuccess] = useState('')
    const navigate = useNavigate()


    const handleEmailChange = (e) => {
        setEmail(e.target.value)
        // Clear any previous messages when user starts typing again
        setError('')
        setSuccess('')
    }

    const handleSubmit = async () => {
        // Basic email validation
        if (!email || !email.includes('@')) {
            setError('Please enter a valid email address')
            return
        }

        setIsLoading(true)
        try {
            const response = await forgotPassword({ email })
             if (response.code === "SUCCESS"){
            setSuccess('Password reset link sent to your email address.')
            setEmail('') // Clear the form after successful submission
            // Wait a moment before redirecting to login
            setTimeout(() => {
                navigate("/auth/login")
            }, 1000) 
          }
        } catch (err) {
            setError(err.message || 'Failed to process your request. Please try again.')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Box
            sx={{
                display: "flex",
                width: "100%",
                mt: 2,
                overflow: "hidden",
            }}
        >
            <Grid container spacing={2} alignItems="stretch">
                <Grid item xs={12} sm={12}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            padding: 2,
                            boxSizing: "border-box",
                            overflow: "hidden",
                            gap: 1,
                            flex: 1,
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                color: theme.palette.heading_color.main,
                                fontWeight: 600,
                                fontSize: { xs: 20, sm: 24 },
                            }}
                        >
                            {constants?.forgot_password?.title}
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                color: theme.palette.heading_color.main,
                                fontWeight: 500,
                                fontSize: { xs: 13, sm: 14 },
                            }}
                        >
                            {constants?.forgot_password?.note}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: { xs: "16px", sm: "18px" },
                                fontWeight: 400,
                                paddingBottom: "4px",
                            }}
                        >
                            {constants?.forgot_password?.section_title}
                        </Typography>
                        <Box
                            sx={{
                                width: "100%",
                                height: "1px",
                                display: "flex",
                                marginBottom: "8px",
                                backgroundColor: theme.palette.seprator_color.main,
                            }}
                        />
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                            }}
                        >
                            {/* Display success message if exists */}
                            {success && (
                                <Typography
                                    sx={{
                                        color: 'green',
                                        mb: 2,
                                        fontSize: { xs: 13, sm: 14 },
                                        fontWeight: 500,
                                        padding: "8px",
                                        backgroundColor: "rgba(0, 128, 0, 0.1)",
                                        borderRadius: "4px",
                                    }}
                                >
                                    {success}
                                </Typography>
                            )}

                            {/* Display error message if exists */}
                            {error && (
                                <Typography
                                    sx={{
                                        color: 'error.main',
                                        mb: 2,
                                        fontSize: { xs: 13, sm: 14 },
                                        padding: "8px",
                                        backgroundColor: "rgba(255, 0, 0, 0.1)",
                                        borderRadius: "4px",
                                    }}
                                >
                                    {error}
                                </Typography>
                            )}

                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: "150px 1fr",
                                    gap: 2,
                                    alignItems: "center",
                                    width: "100%",
                                    padding: "8px 0",
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 600,
                                        color: theme.palette.heading_color.main,
                                        fontSize: { xs: 13, sm: 14 },
                                    }}
                                >
                                    {constants?.forgot_password?.email_label}
                                </Typography>
                                <CommonInput
                                    placeholder={constants?.forgot_password?.email_placeholder}
                                    type="text"
                                    value={email}
                                    onChange={handleEmailChange}
                                />
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                <CommonButton
                                    text={isLoading ? "Sending..." : constants?.forgot_password?.button_text}
                                    bgColor={theme.palette.primary.main}
                                    action={handleSubmit}
                                    disabled={isLoading}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Forgotten